export default {
  disabled: 'Disable',
  enable: 'Enable',
  addStore: 'Add Store',
  storeCode: 'Store Code',
  storeDesc: 'Store Desc',
  storeStatus: 'Status',
  createTime: 'Created Time',
  updateTime: 'Update Time',
  disabledStoreDataTip: 'Are your sure  to disable this store?',
  enableStoreDataTip: 'Are your sure  to enable this store?',
  disabledTunnelMachineDataTip: 'Are your sure  to disable this Tunnel machine?',
  enableTunnelMachineDataTip: 'Are your sure  to enable this Tunnel machine?',
  error_1001: 'Store code is duplicate',
  error_10011: 'Store code cannot be empty',
  error_title_1002: 'Duplicate Tunnel Machine',
  error_1002: 'The tunnel machine code or IP address already exist in the system.',
  error_10021: 'Tunnel machine code cannot be empty',
  error_10022: 'The tunnel machine code format is incorrect',
  error_10023: 'id is not blank',
  error_10024: 'Please input correct ip , it is not blank',
  error_10025: 'Please input correct plant , it is not blank',
  error_10026: 'Please input correct site type , it is not blank',
  error_10027: 'Please input correct site name , it is not blank',
  error_1003: 'The IP address of the tunnel machine cannot be empty',
  error_10031: 'Tunnel machine IP address duplication',
  addTunnelMachine: 'Add Tunnel Machine',
  editTunnelMachine: 'Edit Tunnel Machine',
  tunnelMachineCode: 'Tunnel Machine Code',
  tunnelMachineIp: 'IP Address',
  tunnelMachineStatus: 'Status',
  checkIpv4Format: 'Please enter the correct IPv4 address',
  plant: 'Plant',
  siteType: 'Site Type',
  siteName: 'Site Name',
  createDate: 'Created Date',
  vendor: 'Vendor'
}
